import { render, staticRenderFns } from "./consentementForm.vue?vue&type=template&id=734dcdb2&scoped=true&"
import script from "./consentementForm.vue?vue&type=script&lang=js&"
export * from "./consentementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734dcdb2",
  null
  
)

export default component.exports